import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import get from 'lodash/get'
import set from 'lodash/set'

import Button from '@react/react-spectrum/Button'
import Heading from '@react/react-spectrum/Heading'
import Well from '@react/react-spectrum/Well'
import { error, success } from '@react/react-spectrum/Toast'

import { useAep } from '../../../data/hooks'

import { ProfileContext } from '../../../root/ProfileContext'

import './JourneyTrigger.scss'

const DFAULT_THUMBNAIL = 'https://picsum.photos/200/200'
const IDENTITIES = {
  crmId: '_$tenant.identification.core.crmId',
  ecid: '_$tenant.identification.core.ecid',
  email: '_$tenant.identification.core.email',
  loyaltyId: '_$tenant.identification.core.loyaltyId',
  phone: '_$tenant.identification.core.phoneNumber',
  mobileNb: '_$tenant.identification.core.phoneNumber',
}

const IDENTITY_SOURCES = {
  crmId: 'identityMap.crmid[0].id',
  ecid: 'identityMap.ecid[0].id',
  email: 'identityMap.email[0].id',
  loyaltyId: 'identityMap.loyaltyid[0].id',
  phone: 'identityMap.phone[0].id',
  mobileNb: 'identityMap.mobileNb[0].id',
}

const DATASET_NAMES = [
  'Demo System - Event Dataset for Website (Global v1.1))',
  'Demo System - Event Dataset for CRM (Global v1.1)',
  'Demo System - Event Dataset for Mobile App (Global v1.1)',
  'Demo System - Event Dataset for Customer Experience App (Global v1.1)',
  'Demo System - Event Dataset',
  'Event',
]

function findEventDataset(datasets, schemaId) {
  if (!datasets) return

  const _datasets = Object.entries(datasets).map(([id, { name, schemaRef }]) => ({ id, name, schemaId: schemaRef?.id }))

  // Mach dataset by schemaId
  let dataset = _datasets.find((d) => d.schemaId === schemaId)

  if (dataset) return dataset

  // Match dataset by exact name
  dataset = DATASET_NAMES.reduce((acc, name) => {
    if (acc?.id) return acc
    const ds = _datasets.find((d) => d?.name === name)
    if (ds?.id) return ds
  }, {})

  if (dataset) {
    return dataset
  }

  // Otherwise try to search by name parts
  return DATASET_NAMES.reduce((acc, name) => {
    if (acc?.id) return acc
    const ds = _datasets.find((d) => d?.name?.includes(name))
    if (ds?.id) return ds
  }, {})
}

export default function JourneyTrigger({ content }) {
  const { sendEvent, imsOrg, datasets } = useAep()
  const profileContext = useContext(ProfileContext)
  const { profile, searchParams } = profileContext.state.currentProfile || {}

  const { title, description, thumbnail, mode, event, properties, payload, joTestModeEnabled } = content || {}

  const invalid = !profile || (mode === 'advanced' && !payload) || (mode !== 'advanced' && !event)

  const triggerEvent = () => {
    const uniqueId = `${joTestModeEnabled ? 'joTestModeEvent_' : ''}${Math.random().toString(26).slice(2)}`
    let payloadObject

    if (mode === 'advanced') {
      try {
        payloadObject = JSON.parse(payload)
      } catch (e) {
        error('Incorrect payload. Make sure that payload provided in Experience Builder is valid JSON string.')
        return
      }
    } else {
      payloadObject = {
        header: {},
        body: {
          xdmEntity: {
            eventType: event,
          },
        },
      }
      // implement 'smart' flow
    }

    if (!payloadObject) {
      error('Could not build event payload.')
      return
    }

    // Set metadata

    const dataset = findEventDataset(datasets, payloadObject?.header?.schemaRef?.id)
    const paylaodDataset = get(payloadObject, 'header.datasetId')
    if (!paylaodDataset || paylaodDataset.length < 22 || paylaodDataset.length > 26) {
      set(payloadObject, 'header.datasetId', dataset?.id || '')
    }

    set(payloadObject, 'body.xdmEntity._id', uniqueId)
    set(payloadObject, 'body.xdmEntity.timestamp', new Date())

    // Set identities from current search, profile and identityMap

    Object.entries(IDENTITIES).forEach(([name, path]) => {
      let value
      if (searchParams.entityIdNS === name) {
        value = searchParams.entityId
      }

      if (!value) {
        value = get(profile, 'entity.' + path) || get(profile, 'entity.' + IDENTITY_SOURCES[name])
      }

      set(payloadObject, 'body.xdmEntity.' + path.replace('$tenant', imsOrg?.tenantID), value)
    })

    // Send event

    sendEvent(payloadObject)
    success('Event sent to Experience Platform.')
  }

  return (
    <div className='profile-module event-trigger'>
      <div className='module-content'>
        <Well>
          <div className='journey-thumbnail'>
            <img src={thumbnail || DFAULT_THUMBNAIL} />
          </div>
          <div className='journey-description'>
            <Heading size={2}>{title}</Heading>
            <p>{description}</p>
            <Button label='Trigger Event' onClick={triggerEvent} disabled={invalid} />
          </div>
        </Well>
      </div>
    </div>
  )
}

JourneyTrigger.requiresLaunch = true
